/**
 * @date: 2022-04-18
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import React from "react";
import {Button, styled, TableCell, TableContainer, Tooltip, Typography} from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import InfoIcon from "@mui/icons-material/Info";
import {convertDateToTimeString} from "../utils/cert-helper";
import Box from "@mui/material/Box";
import {ApiUrl} from "../utils/portal-urls";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DownloadIcon from "@mui/icons-material/Download";

const StyledTableRow = styled(TableRow)(({theme}) => ({
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
const StyledTableCell = styled(TableCell)({
    fontWeight: 'bold'
})

export default function AdHocReportBinaryList (props) {
    const { binaries } = props;


    return (
        <TableContainer sx={{mt: '10px'}}>
            <Table sx={{m: 0}}>
                <TableHead>
                    <TableRow >
                        <StyledTableCell>HISP</StyledTableCell>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Field Name</StyledTableCell>
                        <StyledTableCell>Rule Name</StyledTableCell>
                        <StyledTableCell>Type</StyledTableCell>
                        <StyledTableCell>Created Time</StyledTableCell>
                        <StyledTableCell>Report</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {binaries.map( binary => (
                        <StyledTableRow
                            key={binary.id}
                        >
                            <TableCell component="th" scope="row">
                                {binary.hispId}
                            </TableCell>
                            <TableCell>{binary.name}</TableCell>
                            <TableCell>{binary.fieldName}</TableCell>
                            <TableCell>{binary.ruleName}</TableCell>
                            <TableCell>{binary.type}</TableCell>
                            <TableCell>{convertDateToTimeString(binary.createdTs)}</TableCell>
                            <TableCell>
                                <Button href={ApiUrl.Contributions.getBinaryReport.getPath(binary.id)}
                                        target='_blank'
                                        startIcon={<DownloadIcon />}
                                        size='small'
                                >download</Button>
                            </TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}